module.exports = __webpack_public_path__ + "static/media/exit.598dae9e.svg";